import * as t from "io-ts";
import { ElementDependencyAndConditionV } from "./elements";

export const FontV = t.type({
  slug: t.string,
  cssName: t.string,
  label: t.string,
  fallbackString: t.string,
  dependencies: ElementDependencyAndConditionV,
  previewImageUrl: t.union([t.string, t.undefined])
});

export const FontsV = t.array(FontV);

export type Font = t.TypeOf<typeof FontV>;
